import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CreditCardIcon, MapPinIcon, MonitorSmartphoneIcon, UserPlusIcon } from 'lucide-react';
import { quickActions } from '../../data/home';
const icons = {
  user: UserPlusIcon,
  credit: CreditCardIcon,
  map: MapPinIcon,
  online: MonitorSmartphoneIcon
};
export function QuickActions() {
  return <section aria-label="Accès rapides" className="w-full bg-ink" data-id="element-143" data-mp="1ndh0meelr6pa">
      <div className="mx-auto max-w-[1320px] px-6" data-id="element-144" data-mp="219cf881yxvmv">
        <ul className="grid divide-white/10 sm:grid-cols-2 sm:divide-x lg:grid-cols-4" data-id="element-145" data-mp="1x9ttxb68jiji">
          {quickActions.map(action => {
          const Icon = icons[action.icon];
          return <li key={action.label} className="border-b border-white/10 sm:border-b-0" data-id="element-146" data-mp="2613vnpreukza">
                <Link to={action.path} className="group flex items-center gap-4 px-2 py-7 transition-colors sm:px-6 lg:first:pl-0" data-id="element-147" data-mp="2kymtdhm2g8iv">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/5 text-leaf transition-colors group-hover:bg-leaf group-hover:text-ink" data-id="element-148" data-mp="5431na0f73qo">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-149" data-mp="a5abdem4iczz" />
                  </span>
                  <span className="min-w-0 flex-1" data-id="element-150" data-mp="e3gduafxi6f3">
                    <span className="block text-[16px] font-medium text-white" data-id="element-151" data-mp="j44elntym1mi">{action.label}</span>
                    <span className="block text-[13px] text-white/50" data-id="element-152" data-mp="o3qrfw5vlfus">{action.hint}</span>
                  </span>
                  <ArrowRightIcon className="h-4 w-4 text-white/30 transition-[color,transform] duration-200 group-hover:translate-x-1 group-hover:text-leaf" aria-hidden="true" data-id="element-153" data-mp="t10fp8hj3lh1" />
                </Link>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}